import dayjs from "dayjs";
import { useMemo, useState } from "react";

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { actionUseGift, receiveGift } from "../../../api/postApi";
import { useDispatch } from "react-redux";
import { globalTrigger, notice } from "../../../redux/action/action";

dayjs.extend(require("dayjs/plugin/duration"));
const RewardCard = ({
  bonusName,
  bonusAmount,
  expiresIn,
  condition = [],
  buttonProps,
  itemProps = {},
  isGameBox,
  good_type,
}) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`promotions.${key}`);

  const { navigatePath, text } = buttonProps || {};

  const dispatch = useDispatch();

  const [buttonLoading, setButtonLoading] = useState(false);

  const { status_code, good_uid } = itemProps; //按鈕狀態0未完成1已完成2已領取3已過期

  const navigate = useNavigate();

  const formatDiffTime = useMemo(() => {
    if (expiresIn) {
      const diffTime = dayjs(expiresIn)?.diff(dayjs());
      const days = Math.floor(diffTime / (24 * 60 * 60 * 1000));
      const hours = Math.floor(diffTime / (60 * 60 * 1000)) % 24;
      const minutes = Math.floor((diffTime % (60 * 60 * 1000)) / (60 * 1000));
      return `${days}d ${hours}h ${minutes}m`;
    }
  }, [expiresIn]);
  //從simpleRewards.js接收props
  const handleUseGift = (goodUid) => {
    setButtonLoading(true);
    if (good_type === "promotion") {
      receiveGift({
        good_uid: goodUid,
      })
        .then((data) => {
          dispatch(notice("Success", "success"));
          dispatch({ type: "GET_BALANCE" });
          dispatch(globalTrigger());
        })
        .catch((err) => {})
        .finally(() => {
          setButtonLoading(false);
        });
    }
  };

  return (
    <section className="bg-transaction-card dark:bg-base-light-dark p-[15px] rounded-[5px] flex flex-col gap-[10px] mb-[20px] !min-w-[95%] md:min-w-none">
      <span className="text-transaction-text dark:text-light-white text-xl tracking-tight font-medium">
        {bonusName}
      </span>
      <div className="flex flex-col gap-[5px]">
        {itemProps?.conditionKeys?.map((cond) => {
          return (
            <span className="font-light text-sm tracking-tight text-light-text">
              {i18n(cond)}:{" "}
              <span className="text-xl text-transaction-text dark:text-light-white font-medium">
                {condition[cond]}
              </span>
            </span>
          );
        })}
        <span className="font-light text-sm tracking-tight text-light-text">
          {i18n("promotion_reward")}:{" "}
          <span className="text-xl text-transaction-text dark:text-light-white font-medium">
            {condition[`promotion_reward`]}
          </span>
        </span>
      </div>
      <span className="font-light text-sm tracking-tight text-light-text">
        {i18n("Less Expires in")}: <span>{formatDiffTime}</span>
      </span>
      <button
        onClick={() => {
          if (status_code == 1) {
            handleUseGift(good_uid);
          } else {
            navigate(navigatePath);
          }
        }}
        className={`${
          status_code == 1 ? "!bg-green-500" : "!bg-gray-300"
        } py-[10px] ${
          !isGameBox && "!bg-main-color"
        }  text-light-white font-semibold hover:bg-hover-main-bg text-lg rounded-[5px]`}
        type="button"
        disabled={buttonLoading || status_code !== 1}
      >
        {!isGameBox
          ? text
          : status_code == 0
          ? i18n("Cannot Receive")
          : status_code == 1
          ? i18n("Can Receive")
          : status_code == 2
          ? i18n("Already Received")
          : status_code == 99
          ? i18n("Not Eligible")
          : text}
      </button>
    </section>
  );
};

export default RewardCard;
